import { Checkbox } from '@ghq-abi/design-system';

interface RowSelectCheckboxProps {
    checked: boolean;
    onCheckedChange: (checked: boolean) => void;
    disabled?: boolean;
    'data-testid'?: string;
}

export function RowSelectCheckbox({
    checked,
    onCheckedChange,
    disabled,
    'data-testid': dataTestId,
}: RowSelectCheckboxProps) {
    return (
        <Checkbox
            checked={checked}
            onCheckedChange={(value) => onCheckedChange(value === true)}
            disabled={disabled}
            data-testid={dataTestId}
            css={{
                border: '1px solid #D6D6D6',
                backgroundColor: 'white',
                cursor: disabled ? 'not-allowed' : 'pointer',
            }}
        />
    );
}
